import { useState } from "react";
import { Field } from "formik";
import { Minus, Plus } from "react-feather";
import { TextArea } from "../../Form/TextArea/TextArea";
import { ShadowBox } from "../../UI/ShadowBox/ShadowBox";
import styles from "./Accordion.module.scss";
import { Bullets } from "../Bullets/Bullets";

export const Accordion = ({ title, slug }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.root}>
      <ShadowBox>
        <div
          href="#"
          className={styles.headingContainer}
          onClick={() => setOpen(!open)}
        >
          <h2>
            <span>{title}</span>
            {open ? <Minus /> : <Plus />}
          </h2>
        </div>
        {open && (
          <div className={styles.content}>
            <Field
              name={slug + ".description"}
              as={TextArea}
              className={styles.textArea}
            />
            <Bullets slug={slug + ".bullets"} />
          </div>
        )}
      </ShadowBox>
    </div>
  );
};
